import {
  formatError,
  login,
  runLogoutTimer,
  saveTokenInLocalStorage,
  signUp,
} from "../../services/AuthService";

export const SIGNUP_CONFIRMED_ACTION = "[signup action] confirmed signup";
export const SIGNUP_FAILED_ACTION = "[signup action] failed signup";
export const LOGIN_CONFIRMED_ACTION = "[login action] confirmed login";
export const LOGIN_FAILED_ACTION = "[login action] failed login";
export const LOADING_TOGGLE_ACTION = "[Loading action] toggle loading";
export const LOGOUT_ACTION = "[Logout action] logout action";

export function signupAction(email, password, history) {
  return (dispatch) => {
    signUp(email, password)
      .then((response) => {
        saveTokenInLocalStorage(response.data);
        runLogoutTimer(dispatch, response.data.expiresIn * 1000, history);
        dispatch(confirmedSignupAction(response.data));
        history.push("/clients");
      })
      .catch((error) => {
        const errorMessage = formatError(error.response.data);
        dispatch(signupFailedAction(errorMessage));
      });
  };
}

export function logout(history) {
  localStorage.removeItem("userDetails");
  history.push("/login");
  return {
    type: LOGOUT_ACTION,
  };
}

export function loginAction(email_id, password, history) {
  return (dispatch) => {
    login(email_id, password)
      .then((response) => {
        console.log(response.data);

        const logintoken = {
          email: email_id,
          idToken: response.data.accessToken,
          localId: "",
          expiresIn: "43200" /* 3600 */,
          refreshToken: response.data.accessToken,
          userId: response.data.id.toString(),

          /*       email: email,
          refreshToken: response.data.data.token,
          expiresIn: "3600",
          registered: true,
          expireDate: "2022-04-11T11:28:32.619Z", */
        };

        saveTokenInLocalStorage(logintoken);
        /*         runLogoutTimer(dispatch, response?.data.expiresIn * 1000, history); */
        dispatch(loginConfirmedAction(logintoken));
        history.push("/clients");
      })
      .catch((error) => {
        //console.log(error);
        const errorMessage = formatError({
          error: { message: "EMAIL_PASSWORD_NOT_FOUND" },
        });
        dispatch(loginFailedAction(errorMessage));
      });
  };
}

export function loginFailedAction(data) {
  return {
    type: LOGIN_FAILED_ACTION,
    payload: data,
  };
}

export function loginConfirmedAction(data) {
  return {
    type: LOGIN_CONFIRMED_ACTION,
    payload: data,
  };
}

export function confirmedSignupAction(payload) {
  return {
    type: SIGNUP_CONFIRMED_ACTION,
    payload,
  };
}

export function signupFailedAction(message) {
  return {
    type: SIGNUP_FAILED_ACTION,
    payload: message,
  };
}

export function loadingToggleAction(status) {
  return {
    type: LOADING_TOGGLE_ACTION,
    payload: status,
  };
}
